import { Navigate } from "react-router";
import { useGetBuyerUserQuery } from "../../../apis/BuyerUser.api";
import { PrimaryBuyerUser, BuyerUser } from "../../../types/models/BuyerUser";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const BuyerUserScoped = () => {
    const {
        data,
    } = useGetBuyerUserQuery(PrimaryBuyerUser.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/buyer-users/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default BuyerUserScoped;
